import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=c7a6822e&scoped=true&"
import script from "./InfoIcon.vue?vue&type=script&lang=ts&"
export * from "./InfoIcon.vue?vue&type=script&lang=ts&"
import style0 from "./InfoIcon.vue?vue&type=style&index=0&id=c7a6822e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a6822e",
  null
  
)

export default component.exports